import React from 'react';

function StoreHourDetails(props) {
    return <div>To Be Implemented</div>;
}

StoreHourDetails.propTypes = {};

export default StoreHourDetails;
